export enum StartView {
    month,
    year,
    "multi-years"
}